import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=2f0056bc&scoped=true"
import script from "./companyInfo.vue?vue&type=script&lang=js"
export * from "./companyInfo.vue?vue&type=script&lang=js"
import style0 from "./companyInfo.vue?vue&type=style&index=0&id=2f0056bc&prod&scoped=true&lang=css"
import style1 from "./companyInfo.vue?vue&type=style&index=1&id=2f0056bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0056bc",
  null
  
)

export default component.exports